import { store } from "@/store";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";
import { isIgscSchool } from "@/helpers/site-helper";

export const can = (action, subject) => {
  console.log(store.getters["user/abilities"])
  const abilities = store.getters["user/abilities"];
  return abilities.can(action, subject);
};

// IGSC only lets the Admin role view transcripts, the other sites keep
// the permission based rules of each screen.
export const passesIgscTranscriptRule = (
  userRole = store.getters["user/role"]
) => !isIgscSchool() || hasValidRole(userRole, Role.Admin);
